import { Component, Inject, OnInit, Sanitizer, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ChecklistCellDataItem } from '../../../../../models/project/project-info.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeactivationDialogService } from '../../../../../helper/can-deactivate/deactivation-dialog.service';
import { ConfiguredToastrService } from '../../../../../helper/toastr/configured-toastr.service';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { take } from 'rxjs/operators';
import Utils from '../../../../../util';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-edit-cell-dialog',
  templateUrl: './edit-cell-dialog.component.html',
  styleUrls: ['./edit-cell-dialog.component.scss']
})
export class EditCellDialogComponent extends UserpilotReloader implements OnInit {

  @ViewChild('columnForm') form: NgForm;

  trigger: string;
  newItemName: string;

  cellData: ChecklistCellDataItem;
  placeholderText: string;
  iconData = {icon: null, message: null};
  isIcon: boolean;

  isEdit = false;
  isColour = false;
  showClearName = false;
  showClearHint = false;

  constructor(
    private dialogRef: MatDialogRef<EditCellDialogComponent, EditCellDialogResponse>,
    private deactivationDialogService: DeactivationDialogService,
    private toastrService: ConfiguredToastrService,
    private translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: {
      cellData: ChecklistCellDataItem,
      placeholder: string,
      iconData: {icon: string, message: string},
      isIcon: boolean
    },
  ) {
    super();
    if (this.data.cellData !== null) {
      this.isEdit = true;
      this.cellData = this.data.cellData;
    } else {
      this.cellData = new ChecklistCellDataItem();
    }
    this.isColour = this.cellData.items.some(item => item.startsWith('#'));
    this.placeholderText = data.placeholder;
    if (data.iconData != null) {
      this.iconData.icon = data.iconData.icon;
      this.iconData.message = data.iconData.message;
    }
    this.isIcon = data.isIcon;

    this.trigger = this.translationService.getCurrentLang();

    this.dialogRef.backdropClick().pipe(take(1)).subscribe(() => {
      if (this.form.dirty) {
        this.deactivationDialogService.confirm(this.translationService.get('PROJECT.COMMON.DEACTIVATE_CONFIRM'))
          .pipe(take(1)).subscribe(result => {
          if (result) {
            this.dialogRef.close();
          }
        });
      } else {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit() {

  }

  isColourInput() {
    return this.isColour || this.cellData.items.some(item => item.startsWith('#'));
  }

  isColourHexCode(value: string) {
    return value != null && value.startsWith('#');
  }

  getPaletteTooltip() {
    if (this.isColour) {
      return 'PROJECT.PROJECT_INFO.CHECKLIST.NO_COLOUR_ITEMS';
    } else {
      return 'PROJECT.PROJECT_INFO.CHECKLIST.USE_COLOUR_ITEMS';
    }
  }

  onToggleColours() {
    this.isColour = !this.isColour;
    this.cellData.items = [];
    if (this.isColour) {
      this.newItemName = null;
    } else {
      this.newItemName = '';
    }
  }

  onAdd() {
    if (Utils.nameIsUnique(this.newItemName, this.cellData.items.map(item => Utils.stringToNameObject(item)))) {
      this.cellData.items.push(this.newItemName);
      this.newItemName = null;
    } else {
      this.toastrService.error(this.translationService.get('PROJECT.PROJECT_INFO.CHECKLIST.ENTRY_EXISTS'));
    }
  }

  onRemove(name: string) {
    const index = this.cellData.items.findIndex(itemName => itemName === name);
    this.cellData.items.splice(index, 1);
  }

  onSave() {
    if (this.form.valid) {
      this.placeholderText = this.placeholderText?.trim();
      this.dialogRef.close({updatedCellData: this.cellData, placeholder: this.placeholderText, iconData: this.iconData});
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}

export class EditCellDialogResponse {
  updatedCellData: ChecklistCellDataItem;
  placeholder: string;
  iconData: any;
}
